import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhone, FaTriangleExclamation } from 'react-icons/fa6';
import { NATIONAL_GAMBLING_HELPLINE, NATIONAL_GAMBLING_HELPLINE_TEL } from '../data/site';
import './safergamblingbanner.css';

const QUICK_LINKS = [
  { name: 'BeGambleAware', href: 'https://www.begambleaware.org/' },
  { name: 'GamCare', href: 'https://www.gamcare.org.uk/' },
  { name: 'GAMSTOP', href: 'https://www.gamstop.co.uk/' },
  { name: 'UK Gambling Commission', href: 'https://www.gamblingcommission.gov.uk/' },
];

export default function SaferGamblingBanner() {
  return (
    <aside className="sg-banner" aria-label="Safer gambling and support information">
      <div className="container sg-banner__inner">
        <div className="sg-banner__left">
          <span className="sg-banner__badge" aria-hidden="true">18+</span>
          <div className="sg-banner__copy">
            <p className="sg-banner__title">
              <FaTriangleExclamation className="sg-banner__title-ic" size={16} aria-hidden />
              Gambling can be harmful. Play responsibly.
            </p>
            <p className="sg-banner__text">
              Remote gambling in Great Britain is restricted to adults aged <strong>18 and over</strong>. Never bet more than you can afford to lose. If you feel you are losing control, seek help straight away — support is free and confidential.
            </p>
          </div>
        </div>
        <div className="sg-banner__helpline">
          <span className="sg-banner__helpline-label">Need to talk?</span>
          <a href={NATIONAL_GAMBLING_HELPLINE_TEL} className="sg-banner__helpline-num">
            <FaPhone size={14} aria-hidden />
            {NATIONAL_GAMBLING_HELPLINE}
          </a>
          <span className="sg-banner__helpline-note">National Gambling Helpline · 24/7 · UK-wide</span>
        </div>
        <div className="sg-banner__links">
          {QUICK_LINKS.map((l) => (
            <a
              key={l.name}
              href={l.href}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="sg-banner__link"
            >
              {l.name}
            </a>
          ))}
          <Link to="/responsible-gambling" className="sg-banner__link sg-banner__link--internal">
            Our safer gambling guide
          </Link>
        </div>
      </div>
    </aside>
  );
}
